const { keyType } = require('../pix');

const pixKeyType = {
  cpf: 0,
  cnpj: 1,
  email: 2,
  telefone: 3,
  evp: 4,
  convertToJDPI(type) {
    switch (type) {
      case keyType.CPF:
        return this.cpf;
      case keyType.CNPJ:
        return this.cnpj;
      case keyType.EMAIL:
        return this.email;
      case keyType.TELEFONE:
        return this.telefone;
      case keyType.CHAVE_ALEATORIA:
        return this.evp;
      default:
        throw new Error('Invalid pix key type to convert to JDPI');
    }
  }
};

module.exports = pixKeyType;
